function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { useBuildStyleWithTheme } from "../ThemeProvider/useBuildStyleWithTheme";
export function buildStyle(param) {
    var size = param.size, font = param.font;
    return {
        container: {
            base: {
                borderWidth: 0,
                borderRadius: size.border.radius.twoX,
                paddingRight: 8,
                paddingLeft: 8,
                paddingTop: 0,
                paddingBottom: 0,
                display: 'inline-flex',
                '& svg': {
                    fill: font.color.base
                },
                maxWidth: '100%',
                boxSizing: 'border-box'
            }
        },
        innerContainer: {
            base: {
                fontFamily: font.base.family,
                fontSize: font.base.size.xxs,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                verticalAlign: 'baseline',
                boxSizing: 'border-box',
                border: 0,
                padding: '5px 0',
                position: 'relative'
            }
        }
    };
}
export default function useStyle(variant) {
    var tempBackgroundColor = {
        positive: {
            surface: '#E1FFEC'
        },
        negative: {
            surface: '#FFE1E1'
        },
        transitional: {
            surface: '#FFFDE6'
        },
        neutral: {
            surface: '#E5F5FB'
        },
        priority: {
            surface: '#DB2C00'
        },
        inactive: {
            surface: '#D9DCDE'
        }
    };
    var tempFontColor = {
        positive: '#257D23',
        negative: '#B50202',
        transitional: '#B75B00',
        neutral: '#012CB6',
        priority: '#FFFFFF',
        inactive: '#1A2026'
    };
    var ref = useBuildStyleWithTheme(buildStyle), container = ref.container, innerContainer = ref.innerContainer;
    return {
        container: _objectSpread({}, container.base, {
            backgroundColor: variant ? tempBackgroundColor[variant].surface : tempBackgroundColor.positive.surface
        }),
        innerContainer: _objectSpread({}, innerContainer.base, {
            color: variant ? tempFontColor[variant] : tempFontColor.positive
        })
    };
};
